module.exports = __webpack_public_path__ + "img/img_nav_person_hover.b76151de.svg";